module.exports = {
  TAG_CONTENT_CONTEXT: 'tree-constructor-context:tag-content',
  TAG_CONTEXT: 'tree-constructor-context:tag',
  TAG_NAME_CONTEXT: 'tree-constructor-context:tag-name',
  ATTRIBUTES_CONTEXT: 'tree-constructor-context:attributes',
  ATTRIBUTE_CONTEXT: 'tree-constructor-context:attribute',
  ATTRIBUTE_VALUE_CONTEXT: 'tree-constructor-context:attribute-value',
  COMMENT_CONTEXT: 'tree-constructor-context:comment',
  DOCTYPE_CONTEXT: 'tree-constructor-context:doctype',
  DOCTYPE_ATTRIBUTES_CONTEXT: 'tree-constructor-context:doctype-attributes',
  DOCTYPE_ATTRIBUTE_CONTEXT: 'tree-constructor-context:doctype-attribute',
  SCRIPT_TAG_CONTEXT: 'tree-constructor-context:script-tag',
  STYLE_TAG_CONTEXT: 'tree-constructor-context:style-tag'
}
